import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { UserSession } from './authSlice.types';

export type SolarQuoteState = {
  userSession: UserSession | undefined;
};

export const initialState: SolarQuoteState = {
  userSession: undefined,
};

export const authSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    setUserSession: (
      state,
      action: PayloadAction<{ userSession: UserSession | undefined }>
    ) => {
      state.userSession = action.payload.userSession;
    },
    resetAuth: () => {
      return initialState;
    },
  },
  selectors: {
    selectUserSession: (sliceState) => sliceState.userSession,
  },
});

export const { setUserSession } = authSlice.actions;

export const { selectUserSession } = authSlice.selectors;

export default authSlice.reducer;
export type SolarQuoteSlice = typeof authSlice;
